import type { BrandTwoLetterCode } from "brandRegionConfig";

const DomainMap = new Map<string, BrandTwoLetterCode>([
  ["procolor", "PC"],
  ["fixauto", "FA"],
  ["novusglass", "NG"],
  ["speedyauto", "SA"],
  ["speedy", "SA"],
  ["speedyglass", "SG"],
  ["collisionrepairexperts", "CR"],
  ["novuscrystalglass", "NC"],
  ["fixnationrestoration", "NR"],
]);

export default DomainMap;
